import React, { useContext, useState } from 'react';
import './BookingCalendar.scss';
import { LanguageContext } from '../LanguageSwitcher/LanguageContext';
import { useConsent } from '../../lib/consent';

const BOOKING_URL = 'https://calendly.com/mlmindbusiness/30min';

// Calendly URL params so the embed matches the site colors.
const THEME_PARAMS =
  'hide_gdpr_banner=1&background_color=0e2a47&text_color=ffffff&primary_color=e7ff02';

// The embed sets Calendly's cookies, so it renders only after third-party
// consent. Anyone who declined still gets a one-click way to load it for
// this page, or to open Calendly in a new tab.
const BookingCalendar = () => {
  const { translations } = useContext(LanguageContext);
  const consent = useConsent();
  const [loadAnyway, setLoadAnyway] = useState(false);

  const embedUrl = `${BOOKING_URL}${BOOKING_URL.includes('?') ? '&' : '?'}${THEME_PARAMS}`;
  const allowed = Boolean(consent && consent.calendar) || loadAnyway;

  return (
    <div className='booking-calendar'>
      <h2 className='booking-calendar-title'>{translations.bookCall1}</h2>
      <p className='booking-calendar-subtitle'>{translations.bookCall2}</p>
      {allowed ? (
        <div className='booking-calendar-frame'>
          <iframe
            src={embedUrl}
            title={translations.bookCall1}
            frameBorder='0'
          />
        </div>
      ) : (
        <div className='booking-calendar-consent'>
          <p>{translations.calConsentText}</p>
          <div className='booking-calendar-consent-actions'>
            <button type='button' className='booking-calendar-consent-btn' onClick={() => setLoadAnyway(true)}>
              {translations.calConsentBtn}
            </button>
            <a className='booking-calendar-consent-link' href={BOOKING_URL} target='_blank' rel='noreferrer'>
              {translations.calOpenNew} ↗
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingCalendar;
